// Equal height script
function makeEqual() {
    const els = {};
    $('[data-equal]')
        .css('height', '')
        .each(
            /* @this HTMLElement */ function equalizer(i, e) {
                const breakpoint = e.dataset.equalBreakpoint;
                if (
                    $(window).width() >= breakpoint ||
                    typeof breakpoint === 'undefined'
                ) {
                    const foo = e.dataset.equal;
                    const x = $(this).outerHeight(true);
                    if (x > els[foo] || typeof els[foo] === 'undefined') {
                        els[foo] = x;
                    }
                }
            }
        );

    $.each(els, (key, value) => {
        $(`[data-equal="${key}"]`).css('height', `${value}px`);
    });
}

const init = () => {
    $(window).resize(() => {
        makeEqual();
    });

    makeEqual();
};

export { init };
